import announcementService from "src/services/announcementService";

export const GET_ANNOUNCEMENTS_REQUEST = "@announcement/get-announcements-request";
export const GET_ANNOUNCEMENTS_SUCCESS = "@announcement/get-announcements-success";
export const GET_ANNOUNCEMENTS_FAILURE = "@announcement/get-announcements-failure";

export const CREATE_ANNOUNCEMENT_REQUEST = "@announcement/create-announcement-request";
export const CREATE_ANNOUNCEMENT_SUCCESS = "@announcement/create-announcement-success";
export const CREATE_ANNOUNCEMENT_FAILURE = "@announcement/create-announcement-failure";

export const GET_ONE_ANNOUNCEMENT_REQUEST = "@announcement/get_one-announcement-request";
export const GET_ONE_ANNOUNCEMENT_SUCCESS = "@announcement/get_one-announcement-success";
export const GET_ONE_ANNOUNCEMENT_FAILURE = "@announcement/get_one-announcement-failure";

export const UPDATE_ANNOUNCEMENT_REQUEST = "@announcement/update-announcement-request";
export const UPDATE_ANNOUNCEMENT_SUCCESS = "@announcement/update-announcement-success";
export const UPDATE_ANNOUNCEMENT_FAILURE = "@announcement/update-announcement-failure";

export const DELETE_ANNOUNCEMENT_REQUEST = "@announcement/delete-announcement-request";
export const DELETE_ANNOUNCEMENT_SUCCESS = "@announcement/delete-announcement-success";
export const DELETE_ANNOUNCEMENT_FAILURE = "@announcement/delete-announcement-failure";

export function getListAnnouncement(params = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_ANNOUNCEMENTS_REQUEST});
      const response = await announcementService.getListAnnouncement(params);
      dispatch({
        type: GET_ANNOUNCEMENTS_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_ANNOUNCEMENTS_FAILURE});
      throw error;
    }
  };
}

export function createAnnouncement(data) {
  return async (dispatch) => {
    try {
      dispatch({type: CREATE_ANNOUNCEMENT_REQUEST});
      const response = await announcementService.createOneAnnouncement(data);
      dispatch({
        type: CREATE_ANNOUNCEMENT_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: CREATE_ANNOUNCEMENT_FAILURE});
      throw error;
    }
  };
}

export function getOneAnnouncement(data) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_ONE_ANNOUNCEMENT_REQUEST});
      const response = await announcementService.getOneAnnouncement(data);
      dispatch({
        type: GET_ONE_ANNOUNCEMENT_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_ONE_ANNOUNCEMENT_FAILURE});
      throw error;
    }
  };
}

export function updateAnnouncement(data) {
  return async (dispatch) => {
    try {
      dispatch({type: UPDATE_ANNOUNCEMENT_REQUEST});
      const response = await announcementService.updateAnnouncement(data);
      dispatch({
        type: UPDATE_ANNOUNCEMENT_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: UPDATE_ANNOUNCEMENT_FAILURE});
      throw error;
    }
  };
}

export function deleteOneAnnouncement(id) {
  return async (dispatch) => {
    try {
      dispatch({type: DELETE_ANNOUNCEMENT_REQUEST});
      const response = await announcementService.deleteOneAnnouncement(id);
      dispatch({
        type: DELETE_ANNOUNCEMENT_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: DELETE_ANNOUNCEMENT_FAILURE});
      throw error;
    }
  };
}
